<template>
  <label class="app-chip" :class="{ active: isActive }">
    <input
      type="checkbox"
      :checked="isActive"
      :value="item.id"
      :name="name"
      :id="inputId"
      class="visually-hidden"
      @change="$emit('toggle', item.id)"
      v-bind="$attrs"
    />
    {{ item.text }}
  </label>
</template>

<script>
export default {
  name: 'AppChipItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
  },
  computed: {
    inputId() {
      return this.name || `chip-${this._uid}`;
    },
  },
};
</script>

<style scoped>
.visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

.app-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  border: 1px solid #ccc;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.app-chip.active {
  background-color: #4caf50;
  color: white;
  border-color: #4caf50;
}
</style>



// WEBPACK FOOTER //
// AppChip.vue?2b727752